<template>
  <div 
    class="mt-8">
    <v-dialog v-model="dialog.customer"
      @keydown.esc="dialog.customer = false"
      :fullscreen="dialog.fullscreen"
      width="1200"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="pa-8 pt-6">
        <v-card-title 
          class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
          
          Ubah Produk

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#718EBF">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.customer = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon> -->

          <v-icon 
            @click="dialog.customer = false;"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="mt-3">
          <div 
            class="fs-15 label-input">
            Nama Product
          </div>

          <v-autocomplete
            
            filled
            rounded
            dense
            solo
            v-on:change="addVarian()"

            color="#718EBF"
            placeholder="Nama Product"

            
            :items="product"
            item-value="id"
            item-text="name"
            :item-color="set_color"

            v-model="product_id"
            style="border-radius: 10px;">
          </v-autocomplete>
          <v-data-table
            v-model="selected"
            :headers="headers"
            ref="table-grid"
            class="table-grid"
            :items="list"
            height="calc( 100vh - 400px )"
            elevation="0"
            hide-default-footer
            :single-select="false"
            item-key="id"
            show-select
            :items-per-page="1000000000"
            style="border: 1px solid #E7E7E7;"
          >
          </v-data-table>
        </v-card-text>
        

        <v-card-actions
          class="pa-0 pt-4">
          <v-spacer/>

          <v-btn
            rounded
            @click="toAdd()"
            :loading="process.delete"
            width="190"
            height="45"
            elevation="0"
            color="#1814F3"
            class="fs-16 white--text text-capitalize border-radius">
            Pilih
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat
            class="ma-4 mt-0 pb-5"
            style="border-radius: 10px;">
            <v-card-text>
              <div class="color-dark-blue fs-22 font-weight-bold">
                Tambahkan Promo
              </div>
    
              <v-row
                class="">
                <v-col 
                  cols="12"
                  class="px-0">
                  <v-card 
                    flat
                    style="background: transparent;">
                    <v-card-text>
                      <ValidationObserver 
                        ref="form">
                        <v-form>
                          <v-row>
                            <v-col
                              cols="12"
                              :md="form.category === '' ? 6 : form.category === 'area' ? 6 : 4" class="pt-0">
                              <ValidationProvider
                                name="Nama" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Nama
                                </div>
            
                                <v-text-field
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Nama"
            
                                  
            
                                  v-model="form.title"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              :md="form.category === '' ? 6 : form.category === 'area' ? 6 : 4" class="pt-0">
                              <ValidationProvider
                                name="Kategori" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Kategori
                                </div>
            
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  :items="category"
                                  item-value="id"
                                  item-text="name"
                                  v-on:change="toko = allToko; form.store_array = []; form.sales_region_id = ''; form.tipe_toko = ''; form.province_id = ''; form.city_id = ''; form.sub_district_id = '';"
            
                                  color="#718EBF"
                                  placeholder="Kategori"
            
                                  
            
                                  v-model="form.category"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="4" class="pt-0" v-if="form.category === 'kode_sales'">
                              <ValidationProvider
                                name="Kode Sales" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Kode Sales
                                </div>
            
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  :items="kode_sales"
                                  item-value="id"
                                  item-text="name"
                                  v-on:change="filterToko()"
            
                                  color="#718EBF"
                                  placeholder="Kode Sales"
            
                                  
            
                                  v-model="form.sales_region_id"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="4" class="pt-0" v-if="form.category === 'tipe_toko'">
                              <ValidationProvider
                                name="Tipe Toko" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Tipe Toko
                                </div>
            
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  clearable
                                  @click:clear="form.tipe_toko = ''; filterToko();"
                                  :items="[
                                    'Trading (DT1) Pegang Wilayah', 'Trading (DT2) Tidak Pegang Wilayah', 'Grosir (GR1) Jln Utama', 'Grosir (GR2) Masuk dr Jln Utama', 'Grosir (GR3) Pasar', 'Semi Grosir (SG1) Jln Utama', 'Semi Grosir (SG2) Masuk dr Jln Utama', 'Semi Grosir (SG3) Pasar', 'Retail (RT1) Non Pasar', 'Retail (RT2) Pasar', 'Retail (RT3) Komplek/Perumahan', 'Rombong (RT4)', 'Depot Air Minum (RT5)', 'OnOff Retail (RT6)', 'Super Market (MT1)', 'Mini Market (MT2) Jln Utama', 'Mini Market (MT3) Masuk dr Jln Utama', 'Mini Market (MT4) Komplek/Perumahan', 'Personal (P01) Ambil Sendiri', 'Personal (P02) Diantar', 'Kantor/Pabrik/BUMN/BUMD (P03)', 'Pemerintahan/Tentara/Polisi (P04)', 'Dealer/Showroom/Bengkel (P05)', 'Tempat Olah Raga (S01)', 'Tempat Ibadah (S02)', 'Kantin (S03)', 'Rumah Sakit (S04)', 'Catering/Gedung Serba Guna (S05)', 'Restoran (FR1)', 'Rumah Makan (FR2)', 'Warung Makan (FR3)', 'Hotel (HT1)', 'Penginapan (HT2)', 'Proyek (TP1)'
                                  ]"
                                  v-on:change="filterToko()"
            
                                  color="#718EBF"
                                  placeholder="Tipe Toko"
            
                                  
            
                                  v-model="form.tipe_toko"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="4" class="pt-0" v-if="form.category === 'area'">
                              <ValidationProvider
                                name="Provinsi" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  Provinsi
                                </div>
            
                                <v-autocomplete
                                  v-on:keyup.enter="save()"
                                  
                                  v-on:change="changeProvince()"
                                  @click:clear="form.province_id = ''; changeProvince();"
                                  clearable
                                  solo
                                  rounded
                                  dense

                                  color="#718EBF"
            
                                  placeholder="Provinsi"
            
                                  :items="province"
                                  item-value="id"
                                  item-text="name"
            
                                  v-model="form.province_id"
                                  :error-messages="errors"
                                  
                                  style="border-radius: 6px;">
                                </v-autocomplete>
                              </ValidationProvider>
            
                            </v-col>
                            <v-col cols="4" class="pt-0" v-if="form.category === 'area'">
                              <ValidationProvider
                                name="Kota/ Kabpaten" 
                                rules="" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  Kota/ Kabpaten
                                </div>
            
                                <v-autocomplete
                                  v-on:keyup.enter="save()"
                                  
                                  clearable
                                  solo
                                  rounded
                                  dense

                                  color="#718EBF"
                                  hide-details
            
                                  v-on:change="changeCity()"
                                  @click:clear="form.city_id = ''; changeCity();"
                                  placeholder="Kota/ Kabpaten"
            
                                  :items="city"
                                  item-value="id"
                                  item-text="name"
                                  :item-color="set_color"
            
                                  v-model="form.city_id"
                                  :error-messages="errors"
                                  
                                  style="border-radius: 6px; background: #d9e8ff9c !important;">
                                </v-autocomplete>
                              </ValidationProvider>
            
                            </v-col>
                            <v-col cols="4" class="pt-0" v-if="form.category === 'area'">
                              <ValidationProvider
                                name="Kecamatan" 
                                rules="" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  Kecamatan
                                </div>
            
                                <v-autocomplete
                                  v-on:keyup.enter="save()"
                                  
                                  clearable
                                  solo
                                  rounded
                                  dense

                                  color="#718EBF"
                                  hide-details
                                  @click:clear="form.sub_district_id = ''; form.subdistrict_name = ''; filterToko();"
                                  placeholder="Kecamatan"
                                  v-on:change="form.subdistrict_name = subdistrict.find(item => item.id === form.sub_district_id).name; filterToko()"
            
                                  :items="subdistrict"
                                  item-value="id"
                                  item-text="name"
                                  :item-color="set_color"
            
                                  v-model="form.sub_district_id"
                                  :error-messages="errors"
                                  
                                  style="border-radius: 6px; background: #d9e8ff9c !important;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" class="pt-0" v-if="!process.load">
                              <ValidationProvider
                                name="Nama Toko" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Nama Toko
                                </div>
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  :items="toko"
                                  item-value="id"
                                  item-text="name"
                                  multiple
                                  :readonly="form.sales_region_id === '' && (form.tipe_toko === '' || form.tipe_toko === null) && (form.province_id === '' || form.province_id === null) && form.city_id === '' && form.sub_district_id === ''"
            
                                  color="#718EBF"
                                  placeholder="Nama Toko"
                                  v-model="form.store_array"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                  <!-- <template v-slot:selection="{ item }">
                                    <div>
                                      {{ item.product_name }} - {{ item.name }}
                                    </div>
                                  </template>

                                  <template v-slot:item="{ item }">
                                    <div>
                                      {{ item.product_name }} - {{ item.name }}
                                    </div>
                                  </template> -->

                                  <!-- <template v-slot:item="{ item }">
                                    <div class="d-flex align-center">
                                      <div>
                                        <v-checkbox
                                          :input-value="form.product_varian_id.includes(item.id)"
                                        ></v-checkbox>
                                      </div>
                                      <div>
                                        {{ item.product_name }} - {{ item.name }}
                                      </div>
                                    </div>
                                  </template> -->
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" class="pt-0" v-if="!process.load">
                              <ValidationProvider
                                name="Produk" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Produk
                                </div>
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  :items="list"
                                  item-value="id"
                                  :item-text="item => `${item.product_name} - ${item.name}`"
            
                                  color="#718EBF"
                                  placeholder="Produk"
                                  v-model="form.product_varian_id"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                  <template v-slot:selection="{ item }">
                                    <div>
                                      {{ item.product_name }} - {{ item.name }}
                                    </div>
                                  </template>

                                  <template v-slot:item="{ item }">
                                    <div>
                                      {{ item.product_name }} - {{ item.name }}
                                    </div>
                                  </template>

                                  <!-- <template v-slot:item="{ item }">
                                    <div class="d-flex align-center">
                                      <div>
                                        <v-checkbox
                                          :input-value="form.product_varian_id.includes(item.id)"
                                        ></v-checkbox>
                                      </div>
                                      <div>
                                        {{ item.product_name }} - {{ item.name }}
                                      </div>
                                    </div>
                                  </template> -->
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                              <div class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              
                                Tanggal Mulai Promo
                              </div>
  
                              <v-menu
                                v-model="menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                  <ValidationProvider 
                                    name="Tanggal Mulai Promo" 
                                    rules="required" 
                                    v-slot="{ errors }">
                                    <v-text-field
                                      v-model="form.start_date"
                                      
                                      v-on:keyup.enter="save()"
                                      
                                      filled
                                      solo
                                      rounded
                                      dense
                                      
                                      :color="set_color"
                                      placeholder="Tanggal Mulai Promo"
            
                                      :disabled="Object.keys(form).length < 1"
            
                                    
            
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      >
                                    </v-text-field>
                                  </ValidationProvider>
                                </template>
                                <v-date-picker
                                  v-model="form.start_date"
                                  @input="menu2 = false; form.end_date = '';"
                                ></v-date-picker>
                              </v-menu>
  
                            </v-col>
                            <v-col cols="6" class="pt-0">
                              <div class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              
                                Tanggal Akhir Promo
                              </div>
  
                              <v-menu
                                v-model="menu3"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                  <ValidationProvider 
                                    name="Tanggal Akhir Promo" 
                                    rules="required" 
                                    v-slot="{ errors }">
                                    <v-text-field
                                      v-model="form.end_date"
                                      
                                      v-on:keyup.enter="save()"
                                      
                                      filled
                                      solo
                                      rounded
                                      dense
                                      
                                      :color="set_color"
                                      placeholder="Tanggal Akhir Promo"
            
                                      :disabled="Object.keys(form).length < 1 || form.start_date === ''"
            
                                    
            
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      >
                                    </v-text-field>
                                  </ValidationProvider>
                                </template>
                                <v-date-picker
                                  v-model="form.end_date"
                                  :min="form.start_date"
                                  @input="menu3 = false;"
                                ></v-date-picker>
                              </v-menu>
  
                            </v-col>
                            <v-col
                              cols="12"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                name="Tipe Promo" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Tipe Promo
                                </div>
            
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  :items="[{id: 'value', name: 'Value'}, {id: 'qty', name: 'Quantity'}]"
                                  item-value="id"
                                  item-text="name"
                                  v-on:change="reset_all();"
            
                                  color="#718EBF"
                                  placeholder="Tipe Promo"
                                  
                                  v-model="form.value_qty"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="form.value_qty !== ''"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                :name="form.value_qty === 'qty' ? 'Kuota' : 'Nominal'" 
                                rules="required|min_value:1" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  {{ form.value_qty === 'qty' ? 'Kuota' : 'Nominal' }}
                                </div>
            
                                <v-currency-field
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  type="number"
            
                                  color="#718EBF"
                                  :placeholder="form.value_qty === 'qty' ? 'Kuota' : 'Nominal'"
            
                                  v-model="form.quota"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="form.value_qty === 'qty'"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                name="Satuan" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Satuan
                                </div>
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  :items="['Pcs', 'Dus']"
            
                                  color="#718EBF"
                                  placeholder="Satuan"
            
                                  v-model="form.quota_unit"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                                
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="form.value_qty !== ''"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                name="Syarat & Ketentuan" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Syarat & Ketentuan
                                </div>
            
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  :readonly="form.value_qty === 'value'"
                                  dense
                                  solo
                                  v-on:change="reset_qty_type()"
                                  :items="['Bonus Barang', 'Gunakan Minimal Transaksi']"
            
                                  color="#718EBF"
                                  placeholder="Syarat & Ketentuan"
            
                                  v-model="form.qty_type"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="form.value_qty !== '' && form.qty_type === 'Bonus Barang'"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                nama="Jumlah Bonus Barang"
                                rules="required|min_value:1" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Jumlah Bonus Barang
                                </div>
            
                                <v-currency-field
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  type="number"
            
                                  color="#718EBF"
                                  placeholder="Jumlah Bonus Barang"
            
                                  v-model="form.bonus_qty"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="form.value_qty !== '' && form.qty_type === 'Bonus Barang'"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                name="Satuan Bonus Barang" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Satuan Bonus Barang
                                </div>
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  :items="['Pcs', 'Dus']"
            
                                  color="#718EBF"
                                  placeholder="Satuan Bonus Barang"
            
                                  v-model="form.bonus_qty_unit"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                                
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="form.value_qty !== '' ? form.value_qty === 'qty' ? form.qty_type === 'Gunakan Minimal Transaksi' ? true : false : true : false"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                name="Tipe Minimal Transaksi" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Tipe Minimal Transaksi
                                </div>
            
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  :items="[{id: 'value', name: 'Value'}, {id: 'qty', name: 'Quantity'}]"
                                  item-value="id"
                                  item-text="name"
                                  v-on:change="reset_minimum_transaksi()"
            
                                  color="#718EBF"
                                  placeholder="Tipe Minimal Transaksi"
            
                                  v-model="form.minimum_transaksi_type"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="form.value_qty !== '' ? form.value_qty === 'qty' ? form.qty_type === 'Gunakan Minimal Transaksi' ? form.minimum_transaksi_type !== '' ? true : false : false : form.minimum_transaksi_type !== '' ? true : false : false"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                :name="form.minimum_transaksi_type === 'qty' ? 'Minimal Pembelian Quantity' : 'Minimal Pembelian Nominal'"
                                rules="required|min_value:1" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  {{ form.minimum_transaksi_type === 'qty' ? 'Minimal Pembelian Quantity' : 'Minimal Pembelian Nominal' }}
                                </div>
            
                                <v-currency-field
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  type="number"
            
                                  color="#718EBF"
                                  :placeholder="form.minimum_transaksi_type === 'qty' ? 'Minimal Pembelian Quantity' : 'Minimal Pembelian Nominal'"
            
                                  v-model="form.minimum_transaksi"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="form.value_qty !== '' ? form.value_qty === 'qty' ? form.qty_type === 'Gunakan Minimal Transaksi' ? form.minimum_transaksi_type !== '' ? form.minimum_transaksi_type === 'qty' ? true : false : false : false : form.minimum_transaksi_type !== '' ? form.minimum_transaksi_type === 'qty' ? true : false : false : false"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                name="Satuan Minimal Pembelian Quantity" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Satuan Minimal Pembelian Quantity
                                </div>
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  :items="['Pcs', 'Dus']"
            
                                  color="#718EBF"
                                  placeholder="Satuan Minimal Pembelian Quantity"
            
                                  v-model="form.minimum_transaksi_unit"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                                
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="form.value_qty !== '' ? form.value_qty === 'qty' ? form.qty_type === 'Gunakan Minimal Transaksi' ? form.minimum_transaksi_type !== '' ? form.minimum_transaksi_type === 'value' ? true : true : false : false : form.minimum_transaksi_type !== '' ? form.minimum_transaksi_type === 'value' ? true : true : false : false"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                name="Tipe Diskon" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Tipe Diskon
                                </div>
                                <v-autocomplete
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  :items="['Persentase', 'Nominal']"
            
                                  color="#718EBF"
                                  placeholder="Tipe Diskon"
                                  v-on:change="reset_type_diskon()"
            
                                  v-model="form.type_diskon"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                                
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="form.value_qty !== '' ? form.value_qty === 'qty' ? form.qty_type === 'Gunakan Minimal Transaksi' ? form.minimum_transaksi_type !== '' ? form.minimum_transaksi_type === 'value'|| form.minimum_transaksi_type === 'qty' ? form.type_diskon === 'Persentase' ? true : false : false : false : false : form.minimum_transaksi_type !== '' ? form.minimum_transaksi_type === 'value'|| form.minimum_transaksi_type === 'qty' ? form.type_diskon === 'Persentase' ? true : false : false : false : false"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                name="Persen" 
                                rules="required|min_value:1|max_value:100" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Persen
                                </div>
            
                                <v-currency-field
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  type="number"
            
                                  color="#718EBF"
                                  placeholder="Persen"
            
                                  v-model="form.percent"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="form.value_qty !== '' ? form.value_qty === 'qty' ? form.qty_type === 'Gunakan Minimal Transaksi' ? form.minimum_transaksi_type !== '' ? form.minimum_transaksi_type === 'value'|| form.minimum_transaksi_type === 'qty' ? form.type_diskon === 'Nominal' ? true : false : false : false : false : form.minimum_transaksi_type !== '' ? form.minimum_transaksi_type === 'value'|| form.minimum_transaksi_type === 'qty' ? form.type_diskon === 'Nominal' ? true : false : false : false : false"
                              :md="12" class="pt-0">
                              <ValidationProvider
                                name="Nominal" 
                                rules="required|min_value:1" 
                                v-slot="{ errors }">
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Nominal
                                </div>
            
                                <v-currency-field
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
                                  type="number"
            
                                  color="#718EBF"
                                  placeholder="Nominal"
            
                                  v-model="form.nominal"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="12"
                              md="12" class="pt-0">
                              <!-- <ValidationProvider
                                name="Persentase Promo" 
                                rules="" 
                                v-slot="{ errors }"> -->
                                <div 
                                  class="fs-15 label-input">
                                  
                                  Deskripsi
                                </div>
            
                                <v-textarea
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Deskripsi"
  
                                  
            
                                  v-model="form.desc"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-textarea>
                              <!-- </ValidationProvider> -->
                            </v-col>
                          </v-row>
                          <!-- <div
                            class="mb-4">
                            <div 
                              class="body-2 mb-2">
                              Poto Profil
                            </div>
    
                            <uploadfolder v-if="form.image_url === ''"
                              v-model="upload.image">
                              <div 
                                slot="activator">
                                <v-card 
                                  flat
                                  width="200"
                                  height="200"
                                  class="d-flex align-center justify-center cursor-pointer"
                                  style="border-radius: 15px;
                                        border: 2px solid #EBEBEB; 
                                        border-style: dashed;">
                                  <v-avatar v-if="!process.image"
                                    v-ripple
                                    tile 
                                    width="200"
                                    height="200">
                                    <v-icon
                                      size="50"
                                      color="#B9B9B9">
                                      mdi-cloud-upload-outline
                                    </v-icon>
                                  </v-avatar>
    
                                  <v-progress-circular v-else
                                    indeterminate
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-card>
                              </div>
                            </uploadfolder>
    
                            <v-card v-if="form.image_url !== ''"
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar
                                v-ripple
                                tile 
                                size="200"
                                style="border-radius: 15px;">
                                <v-img 
                                  contain
                                  width="100%"
                                  height="100%"
                                  alt="Mitra Warung" 
                                  :src="form.image_url"
                                  class="ma-auto"
                                  style="border-radius: 15px;">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-avatar>
    
                              <v-icon 
                                @click="form.image_url = ''"
                                color="red"
                                class="cursor-pointer"
                                style="position: absolute; top: -10px; right: -10px;">
                                mdi-close-circle
                              </v-icon>
                            </v-card>
                          </div> -->
    
    
    
                        </v-form>
                      </ValidationObserver>
    
                      <div v-if="message.error.length > 0"
                        class="text-center my-4 d-flex align-center">
                        <div
                          class="error--text">
                          <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                          
                          <span
                            class="ml-1">
                            {{ message.error }}
                          </span>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
    
              <v-row
                justify="end"
                class="pa-4 pr-1">
                <v-col 
                  cols="12"
                  md="12"
                  class="d-flex align-center justify-end py-0">
                  <v-btn 
                    @click="save()"
                    :loading="process.form"
                    :disabled="process.form"
                    width="190"
                    height="45"
                    elevation="0"
                    color="#1814F3"
                    class="fs-16 white--text text-capitalize border-radius">
                    Simpan
                  </v-btn>
                  
                  <v-btn
                    @click="$router.go(-1)"
                    :disabled="process.form"
                    color="red"
                    elevation="0"
                    width="140"
                    height="45"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                    style="font-weight: 600;">
                  
                      Batal
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          customer: false,
          fullscreen: false
        },
        markers: [],
        sales: [],
        toko: [],
      place: null,
        form: {
          id: '',
          category: '',
          title: '',
          desc: '',
          start_date: '',
          end_date: '',
          product_varian_id: '',
          value_qty: '',
          quota_unit: '',
          quota: '',
          minimum_transaksi: '',
          minimum_transaksi_type: '',
          minimum_transaksi_unit: '',
          percent: '',
          nominal: '',
          bonus_qty: '',
          qty_type: '',
          type_diskon: '',
          bonus_qty_unit: '',
          sales_region_id: '',
          tipe_toko: '',
          province_id: '',
          city_id: '',
          sub_district_id: '',
          subdistrict_name: '',
          city_name: '',
          province_name: '',
          store_array: [],
        },
        kode_sales: [],

        lastIndex: 1,
        sales_region_id: '',
        product: [],
        product_id: '',
        selected: [],
        headers: [
                // {
                //   text: 'No',
                //   width: '80',
                //   value: 'index',
                //   freeze: true,
                //   hide: false
                // },
                {
                  text: 'Nama',
                  width: '150px',
                  value: 'name',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'SKU',
                  width: '180px',
                  value: 'sku',
                  freeze: false,
                  hide: false
                },
              
              ],
        category: [
          { id: 'kode_sales', name: 'Kode Sales' },
          { id: 'tipe_toko', name: 'Tipe Toko' },
          { id: 'area', name: 'Area' }
        ],
        list: [],
        province: [],
        city: [],
        subdistrict: [],
        village: [],
        customer: [],
        sales: [],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        menu3: false,
        grand_total: 0,

        // selected: {
        //   row: [],
        //   freeze: [],
        //   delete: [],

        //   menu: 'Koordinat'
        // },

        map: null,
        allToko: [],

        center: {
          lat: -2.9198476, 
          lng: 104.645729
        },

        upload: {
          images: null
        },

        process: {
          form: false,

          file: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.images': {
        handler: function () {
          if (this.upload.images) {
            this.process.images = this.upload.images.process

            if (!this.process.images) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.images = this.upload.images.fileuri
              // this.upload.images.map(obj => {
                this.form.images.push(
                  this.upload.images.fileuri
                )
              // })

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
        return this.headers_data.filter(header => !header.hide)  
      },
    },
    mounted () {
        this.fetchDetail()
      },
      methods: {
        async fetchDetail () {
          this.process.load = true
          let params = {
            id: this.$route.params.id
          }
  
          await get('admin/promo/detail', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.detail = res.results.data
              this.form = {
                id: this.detail.id,
                category: this.detail.category,
                title: this.detail.title,
                desc: this.detail.desc,
                start_date: this.detail.start_date,
                end_date: this.detail.end_date,
                product_varian_id: this.detail.product_varian_id,
                value_qty: this.detail.value_qty,
                quota_unit: this.detail.quota_unit,
                quota: this.detail.quota*1,
                minimum_transaksi: this.detail.minimum_transaksi*1,
                minimum_transaksi_type: this.detail.minimum_transaksi_type,
                minimum_transaksi_unit: this.detail.minimum_transaksi_unit,
                percent: this.detail.percent*1,
                nominal: this.detail.nominal*1,
                bonus_qty: this.detail.bonus_qty*1,
                qty_type: this.detail.value_qty === 'qty' ? this.detail.minimum_transaksi !== '0' ? 'Gunakan Minimal Transaksi' : 'Bonus Barang'  : 'Gunakan Minimal Transaksi',
                type_diskon: this.detail.percent !== '0' ? 'Persentase' : 'Nominal',
                bonus_qty_unit: this.detail.bonus_qty_unit,
                sales_region_id: this.detail.sales_region_id,
                tipe_toko: this.detail.tipe_toko,
                province_id: this.detail.province_id,
                city_id: this.detail.city_id,
                sub_district_id: this.detail.sub_district_id,
                province_name: '',
                city_name: '',
                subdistrict_name: '',
                store_array: [],
              }
              res.results.data.promo_store.map(obj => {
                this.form.store_array.push(obj.store_id)
              })
              this.fetchToko()
              this.fetchProduct()
              this.fetchVarian()
              this.fetchProv()
              this.fetchProvUbah()
              this.fetchCityUbah()
              this.fetchSubUbah()
              this.fetchKodeSales()
            }
          })
        },
      async fetchToko () {
        this.process.load = true

        let params = {
          limit: 1000000,
          sales_region_id: this.form.sales_region_id,
          province_name: this.form.province_name,
          city_name: this.form.city_name,
          subdistrict_name: this.form.subdistrict_name,
          type: this.form.tipe_toko,
          status:'approved',
          is_blacklist: '0',
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/toko/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.toko = res.results.data
            this.allToko = res.results.data
            
          }
          this.process.load = false
        })
      },
      async fetchKodeSales() {

        let params = {
          limit: 10000000000000
        }

        await get(`admin/sales_region/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.kode_sales = res.results.data
          }
        })
      },
      async fetchProv() {

       let params = {
        limit: 10000000000000
      }

      await get(`ref/provinsi`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.province = res.results.data
        }
      })
    },
    async fetchProvUbah() {

       let params = {
        limit: 10000000000000
      }

      await get(`ref/provinsi`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.province = res.results.data
          this.form.province_name = this.province.find(obj => obj.id === this.form.province_id).name
        }
      })
    },

    changeProvince() {
      this.form.city_id = ''
      this.form.sub_district_id = ''
      this.form.city_name = ''
      this.form.subdistrict_name = ''
      let id = this.form.province_id
      this.form.province_name = this.form.province_id === null || this.form.province_id === '' ? '' : this.province.find(obj => obj.id === id).name
      this.fetchCity(id)
      this.filterToko()
    },

    async fetchCity(id) {

       let params = {
        limit: 10000000000000,
        province_id: id
      }

      await get(`ref/kota`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.city = res.results.data
        }
      })
    },
    async fetchCityUbah() {

       let params = {
        limit: 10000000000000,
        province_id: this.form.province_id
      }

      await get(`ref/kota`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.city = res.results.data
          this.form.city_name = this.city.find(obj => obj.id === this.form.city_id).name
        }
      })
    },
    changeCity() {
      this.form.sub_district_id = ''
      this.form.subdistrict_name = ''
      let id = this.form.city_id
      this.form.city_name = this.form.city_id === null || this.form.city_id === '' ? '' : this.city.find(obj => obj.id === id).name
      this.fetchSub(id)
      this.filterToko()
    },
    // changeCity() {
    //   this.form.subdistrict_name = ''
    //   let id = ''
    //   this.city.map(obj => {
    //     if (obj.name === this.form.city_name) {
    //       id = obj.id
    //     }
    //   })
    //   this.fetchSub(id)
    // },

    async fetchSub(id) {

       let params = {
        limit: 10000000000000,
        city_id: id
      }

      await get(`ref/kecamatan`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.subdistrict = res.results.data
        }
      })
    },
    async fetchSubUbah() {

       let params = {
        limit: 10000000000000,
        city_id: this.form.city_id
      }

      await get(`ref/kecamatan`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.subdistrict = res.results.data
          this.form.subdistrict_name = this.subdistrict.find(obj => obj.id === this.form.sub_district_id).name
        }
      })
    },
    filterToko() {
      this.toko = []
      this.form.store_array = []
      this.fetchToko()
      // this.toko = []
      // if(this.form.province_name !== '' && this.form.city_name !== '' && this.form.subdistrict_name !== '' && this.form.province_name !== null && this.form.city_name !== null && this.form.subdistrict_name !== null) {
      //   this.allToko.map(obj => {
      //     if(obj.province_name === this.form.province_name && obj.city_name === this.form.city_name && obj.subdistrict_name === this.form.subdistrict_name) {
      //       this.toko.push(obj)
      //     }
      //   })
      // } else if(this.form.province_name !== '' && this.form.city_name !== '' && this.form.province_name !== null && this.form.city_name !== null) {
      //   this.allToko.map(obj => {
      //     if(obj.province_name === this.form.province_name && obj.city_name === this.form.city_name) {
      //       this.toko.push(obj)
      //     }
      //   })
      // } else if(this.form.province_name !== '' && this.form.province_name !== null) {
      //   this.allToko.map(obj => {
      //     if(obj.province_name === this.form.province_name) {
      //       this.toko.push(obj)
      //     }
      //   })
      // } else {
      //   this.toko = this.allToko
      // }

      // if(this.form.tipe_toko !== '') {
      //   this.allToko.map(obj => {
      //     if(obj.type === this.form.tipe_toko) {
      //       this.toko.push(obj)
      //     }
      //   })
      // }

      // if(this.form.sales_region_id !== '') {
      //   this.allToko.map(obj => {
      //     if(obj.sales_region_id === this.form.sales_region_id) {
      //       this.toko.push(obj)
      //     }
      //   })
      // }
    },
      async fetchProduct () {
        this.process.load = true

        let params = {
          limit: 1000000,
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/product/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.product = res.results.data
            
          }
          this.process.load = false
        })
      },
      addVarian() {
        let list = []
        this.list = []
        this.fetchVarian()
      },
      toAdd() {
        this.form.varian_arr = []
        this.dialog.customer = false
        this.form.varian_arr.push(...this.selected)
        // this.form.varian_arr = this.selected
      },
      async fetchVarian () {
        this.list = []
        // this.process.load = true

        // this.limit = pagination.row

        let params = {
          limit: 100000000000000000
        }

        // admin/services/data
        
        await get(`admin/varian/data`, { params })
        .then(response => {
          let res = response.data
          
          this.process.load = false
          
          this.list = []
          this.pagination = {}
          
          if (res.status === 200) {
            this.headers = [
              // {
              //   text: 'No',
              //   width: '80',
              //   value: 'index',
              //   freeze: true,
              //   hide: false
              // },
              {
                text: 'Nama',
                width: '150px',
                value: 'name',
                freeze: true,
                hide: false
              },
              {
                text: 'SKU',
                width: '180px',
                value: 'sku',
                freeze: false,
                hide: false
              },
              {
                text: 'Produk',
                width: '200px',
                value: 'product_name',
                freeze: false,
                hide: false
              },
            
            ]

            this.headers_data = [
              {
                text: 'No',
                width: '80',
                value: 'index',
                freeze: true,
                hide: false
              },
              {
                text: 'Nama',
                width: '300px',
                value: 'name',
                freeze: true,
                hide: false
              },
              {
                text: 'SKU',
                width: '180px',
                value: 'sku',
                freeze: false,
                hide: false
              },
              {
                text: 'Produk',
                width: '200px',
                value: 'product_name',
                freeze: false,
                hide: false
              },

              {
                text: '',
                width: '100px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'right',
                format: 'action'
              },
            
            ]
    

            res.results.data.map((item) => {
              this.list.push({
                ...item
              })
            })
          }
        })
      },
      reset_all () {
        this.form = {
          id: this.form.id,
          category: this.form.category,
          title: this.form.title,
          desc: this.form.desc,
          start_date: this.form.start_date,
          end_date: this.form.end_date,
          product_varian_id: this.form.product_varian_id,
          value_qty: this.form.value_qty,
          sales_region_id: this.form.sales_region_id,
          tipe_toko: this.form.tipe_toko,
          province_id: this.form.province_id,
          city_id: this.form.city_id,
          sub_district_id: this.form.sub_district_id,
          subdistrict_name: this.form.subdistrict_name,
          city_name: this.form.city_name,
          province_name: this.form.province_name,
          store_array: this.form.store_array,
          quota_unit: '',
          quota: '',
          minimum_transaksi: '',
          minimum_transaksi_type: '',
          minimum_transaksi_unit: '',
          percent: '',
          nominal: '',
          bonus_qty: '',
          qty_type: this.form.value_qty === '' ? '' : this.form.value_qty === 'value' ? 'Gunakan Minimal Transaksi' : '',
          type_diskon: '',
          bonus_qty_unit: ''
        }
      },
      reset_type_diskon () {
        if (this.$refs.form) this.$refs.form.reset()
        this.form.percent = ''
        this.form.nominal = ''
      },
      reset_qty_type () {
        if (this.$refs.form) this.$refs.form.reset()
        this.form.bonus_qty = ''
        this.form.bonus_qty_unit = ''
        this.form.minimum_transaksi_type = ''
        this.reset_minimum_transaksi()
      },
      reset_minimum_transaksi () {
        if (this.$refs.form) this.$refs.form.reset()
        this.form.minimum_transaksi = ''
        this.form.minimum_transaksi_unit = ''
        this.form.type_diskon = ''
        this.reset_type_diskon()
      },
      openDialog () {
        this.selected = []
        this.selected.push(...this.form.varian_arr)
        this.dialog.customer = true
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.form.minimum_transaksi_unit = this.form.minimum_transaksi_type === 'value' ? 'Rupiah' : this.form.minimum_transaksi_unit
          this.form.quota_unit = this.form.value_qty === 'qty' ? this.form.quota_unit : 'Rupiah'
          this.form.sales_region_id = this.form.category === 'kode_sales' ? this.form.sales_region_id : 0
          let form = {
            ...this.form,
            percent: this.form.type_diskon === 'Persentase' ? this.form.percent : 0,
            nominal: this.form.type_diskon === 'Nominal' ? this.form.nominal : 0,
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/promo/update`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/promo/data' })
              // this.$router.go(-1)

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>